import createVueComponent from '../createVueComponent';

const Tally2 = createVueComponent('Tally2Icon', [
  ['path', { d: 'M4 4v16', key: '6qkkli' }],
  ['path', { d: 'M9 4v16', key: '81ygyz' }],
]);

export default Tally2;
